export default __webpack_public_path__ + "static/media/web3_sphere.1a674f70.svg";